import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  showSuccess(message, title, ToastConfig) {
    this.toastr.success(message, title, ToastConfig);
  }

  showError(message, title, ToastConfig) {
    this.toastr.error(message, title, ToastConfig);
  }

  showInfo(message, title) {
    this.toastr.info(message, title);
  }

  showWarning(message, title) {
    this.toastr.warning(message, title);
  }
}
